import React, { useEffect, useRef, useState } from 'react';
import { Alert, Form } from 'antd';
import { CalendarOutlined, InfoCircleOutlined } from '@ant-design/icons';
import ReactDOM from 'react-dom';
import CalendarFormRender from '../components/Calendar';
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

export default (formPlugin, namespace) => {
    const calendars = formPlugin.formData?.calendars || []

    return {
        Renderer: (props) => {

            let containerRef = useRef(null)
            const [listField, setlistField] = useState(null)
            useEffect(() => {
                setlistField(props.pluginConfig.getListField(containerRef.current))
            }, [])

            if (props.remove) {
                formPlugin.onAddFormPlugin(props, props.nodeId, props.pluginConfig.id)
            }

            if (!props.data.calendarId) {
                if (!props.isPreviewMode && !props.readOnly) {
                    return (
                        <Alert showIcon type={"warning"} message={t`Veuillez choisir un calendrier.`}/>
                    )
                }
                return null
            }

            const {data} = props

            const calendarId = (data.calendarId.split("=>")[data.calendarId.split("=>").length - 1]).trim()

            let rules = [{required: data.required || false, message: t`Ce champ est obligatoire`}]

            let tooltip = null
            if (data.tooltip) {
                tooltip = {
                    title: data.tooltip,
                    icon: <InfoCircleOutlined/>,
                }
            }

            const listFieldProps = listField ? listField : null
            const finalName = "[CALENDAR]_" + calendarId
            return (
                <div ref={(ref) => containerRef.current = ref}>
                    <Form.Item
                        {...listFieldProps}
                        label={data.label}
                        name={listField ? [listField.name, finalName].flat() : finalName}
                        rules={rules}
                        tooltip={tooltip}
                    >
                        <CalendarFormItem calendarId={calendarId}/>
                    </Form.Item>
                </div>
            )
        },
        namespace: namespace,
        id: 'form-calendar' + namespace,
        title: t`Calendrier`,
        description: t`Élément de formulaire utilisable.`,
        icon: <CalendarOutlined/>,
        iconColor: "#2980B9",
        version: 1,
        getListField: (containerRef) => {
            const listField = ReactDOM.findDOMNode(containerRef)?.closest(".form-field")?.dataset.field
            if (listField) {
                return JSON.parse(listField)
            }
            return null
        },
        controls: {
            type: 'autoform',
            schema: {
                properties: {
                    required: {
                        type: 'boolean',
                        uniforms: {
                            label: t`Obligatoire`,
                        }
                    },
                    calendarId: {
                        type: 'string',
                        uniforms: {
                            required: true,
                            label: t`Calendrier`,
                            placeholder: t`Calendrier`,
                            allowedValues: calendars.map(i => i.label + " => " + i.id),
                        }
                    },
                    label: {
                        type: 'string',
                        uniforms: {
                            required: false,
                            label: t`Étiquette`,
                            placeholder: t`Libellé`,
                        }
                    },

                    tooltip: {
                        type: 'string',
                        uniforms: {
                            label: t`Message d'aide`,
                            placeholder: t`Message d'aide`,
                            multiline: true,
                            rows: 2,
                        }
                    },
                }
            },
        },
    }

    function CalendarFormItem({value, onChange, calendarId}) {
        const [slots, setSlots] = useState([])
        const [currentMonthDate, setCurrentMonthDate] = useState(new Date())

        const getSlots = async () => {
            const _slots = await formPlugin.getAvailableCalendarSlots(calendarId, currentMonthDate.getMonth(), currentMonthDate.getFullYear())
            setSlots(_slots)
        }

        useEffect(() => {
            getSlots()
        }, [currentMonthDate]);

        return (
            <CalendarFormRender
                value={value}
                onChange={(_value) => {
                    if (onChange) {
                        onChange(_value)
                    }
                    formPlugin.rerenderProducts()
                }}
                slots={slots}
                onChangePanel={(_date) => setCurrentMonthDate(_date)}
            />
        )
    }
}
